$( document ).ready(function(){

    function getLocation() 
    {
      if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(setPosition);
      } 
      else { 
        alert("Geolocation is not supported by this browser.");
      }
    }
    function setCookie(name,value,days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }

    function setPosition(position) 
    {

        osmSearchLatLng(position.coords.latitude, position.coords.longitude, function (address) {
            if(address){
                let city = "";
                let area = "";
                let postcode = "";


                if(address.city){
                    city = address.city;
                } else if(address.town){
                    city = address.town;
                } else if(address.village){
                    city = address.village;
                }
                if(address.region){
                    area = address.region;
                } else if(address.state){
                    area = address.state;
                } else if(address.county){
                    area = address.county;
                }
                if(address.postcode){
                    postcode = address.postcode;
                }

                setCookie('userLocation_Lat', position.coords.latitude, 1 );
                setCookie('userLocation_Lng', position.coords.longitude, 1 );
                setCookie('userLocation_City', city, 1 );
                setCookie('userLocation_Area', area, 1 );
                setCookie('userLocation_Postcode', postcode, 1 );

                const url = window.location.href;
                if(url){
                    window.location.href = url;
                }
            }
        });
    }

    

    if ( $('#set-geolocation').length )
    {
      $("#set-geolocation").on('click', function(e) 
      {
          e.preventDefault();
          localStorage.removeItem('storedLocVars');
          getLocation();   
      });
    }

});